export function cartItemToFB(it) {
  return {
    id: it.id,
  };
}
